import React, {Component} from 'react';
import {
  Router,
  Switch,
  Route,
} from 'react-router-dom';
import history from '../../../../services/history';
import Login from './components/Login';
import Callback from './components/Callback';
import RelayRootContainer from './components/RelayRootContainer';

class AuthContainer extends Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/callback" component={Callback} />
          <Route path="/" component={RelayRootContainer} />
        </Switch>
      </Router>
    );
  }
}

export default AuthContainer;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/AuthContainer.js